"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
require("./LoadingSpinner.scss");
const framer_motion_1 = require("framer-motion");
const LoadingSpinner = (props) => {
    var ctx = (0, spa_core_1.useEpiserver)();
    var timeout = props.timeout || ctx.config().spinnerTimeout || 0;
    var [isVisible, setIsVisible] = (0, react_1.useState)(timeout === 0);
    if (ctx.config().enableSpinner !== true)
        return null;
    const accessibilityText = ctx.Language === 'fi' ? 'Ladataan sisältöä' : 'Loading content';
    (0, react_1.useEffect)(() => {
        if (timeout === 0)
            return;
        setIsVisible(false);
        const timeoutHandle = setTimeout(() => { setIsVisible(true); }, timeout);
        return () => {
            clearTimeout(timeoutHandle);
        };
    }, []);
    if (isVisible) {
        return react_1.default.createElement("div", { className: 'loading', role: 'status', "aria-live": 'polite', "aria-label": accessibilityText },
            react_1.default.createElement("div", { className: 'container-style' },
                react_1.default.createElement(framer_motion_1.motion.span, { className: 'circle-style', animate: { rotate: 22.5 } })));
    }
    return null;
};
exports.LoadingSpinner = LoadingSpinner;
exports.default = exports.LoadingSpinner;
